<template>
	<v-card class="settings-page" flat>
		<PageBlocked v-if="isBlocked" :blockRole="blockRole" />
		<div v-else-if="isBlocked !== null">
			<v-alert v-model="successMessage" type="success" dismissible>
				Settings saved successfully.
			</v-alert>
			<v-alert v-model="errorMessage" type="error" dismissible> An error occurred. </v-alert>
	
			<v-card-text v-if="isPageVisible">
				<h1 class="mb-5">Settings</h1>
	
				<v-list class="settings-page__item-wrapper pa-4">
	
					<v-list-item class="settings-page__item" v-if="baseSetting.termsOfUse">
						<v-list-item-content class="pa-0">
							<a
								:href="baseSetting.termsOfUse"
								target='_blank'
							>
								Terms of Use
							</a>
						</v-list-item-content>
					</v-list-item>
	
					<v-list-item class="settings-page__item" v-if="baseSetting.privacy">
						<v-list-item-content class="pa-0">
							<a
								:href="baseSetting.privacy"
								target='_blank'
							>
								Privacy Policy
							</a>
						</v-list-item-content>
					</v-list-item>
	
					<v-list-item class="settings-page__item" v-if="baseSetting.contactUrl">
						<v-list-item-content class="pa-0">
							<a
								:href="baseSetting.contactUrl"
								target='_blank'
							>
								Contact Us
							</a>
						</v-list-item-content>
					</v-list-item>
	
				</v-list>
	
			</v-card-text>
		</div>
	</v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PageBlocked from '@/components/PageBlocked'
import Block from '@/mixins/Block.js'

export default {
	name: 'SettingsPage',
	mixins: [Block],
	components: {
		PageBlocked
	},
	computed: {
		...mapGetters('settings', ['settings', 'baseCore', 'appCore']),
		...mapGetters('auth', ['profile']),

		isVerticalTabs() {
			return this.$vuetify.breakpoint.mdAndUp
		},
		baseSetting() {
			if (this.baseCore) {
				const {
					privacy_policy: privacy,
					terms_of_use: termsOfUse,
					contact_us_url: contactUrl
				} = this.baseCore || {}

				return {
					privacy,
					termsOfUse,
					contactUrl
				}
			}
			return {}
		},
		isPageVisible() {
			if (!this.baseCore) {
				return null
			}
			return this.baseCore.privacy_policy || this.baseCore.terms_of_use || this.baseCore.contact_us_url
		}
	},
	watch: {
		baseCore(newValue) {
			if (newValue && !newValue.privacy_policy && !newValue.terms_of_use && !newValue.contact_us_url ) {
				this.$router.back()
			}
		}
	},
	methods: {
		...mapActions('settings', ['fetchSettings', 'getBaseCoreSettings']),
		onTabSwitch() {
			this.successMessage = false
			this.errorMessage = false
		},
		normalizeSettings(item) {
			const { setting, value } = item

			let settings = {}
			settings[setting.name] = value !== '0'

			return settings
		},
		getRoute(initValue) {
			const url = new URL(initValue);
			return url.pathname;
		}
	},
	data() {
		return {
			successMessage: false,
			errorMessage: false,
			pageBlockedName: 'settings'
		}
	},
	created() {
		this.getBaseCoreSettings()
	},
}
</script>

<style lang="scss">
.settings-page {
	font-family: Montserrat,sans-serif;
	max-width: 600px;
	width: 100%;
	background-color: transparent !important;

	&__item {
		min-height: auto;
		
		a {
			font-size: 14px !important;
			line-height: 17.07px;
			font-weight: 700;
			color: var(--ceil-detail-text-color) !important;
		}

		&-wrapper {
			display: flex;
			flex-direction: column;
			row-gap: 12px;
			border-radius: 10px !important;
		}
	}

	&__title {
		font-style: normal;
		font-weight: bold;
		font-size: 40px;
		line-height: 35px;
		color: #202232;
	}

	@media screen and (max-width: 960px) {
		.settings-page__title {
			font-size: 25px !important;
		}
	}
}
</style>
